function toggleDropdown(dropdown) {
    if (dropdown.hasAttribute('closed')) return openDropdown(dropdown);
    closeDropdown(dropdown);
}

function openDropdown(dropdown) {
    dropdown.style.height = '0px';
    dropdown.removeAttribute('closed');
    const height = dropdown.scrollHeight;
    dropdown.style.height = height + 'px';

    dropdown.addEventListener('transitionend', () => {
        dropdown.style.height = 'auto';
    }, { once: true });
}

function closeDropdown(dropdown) {
    const height = dropdown.scrollHeight;
    dropdown.style.height = height + 'px';
    dropdown.offsetHeight;
    dropdown.style.height = '0px';
    dropdown.setAttribute('closed', '');

    dropdown.addEventListener('transitionend', () => {
        dropdown.style.height = '';
    }, { once: true });
}

document.addEventListener('DOMContentLoaded', () => {
    const dropdownSync = document.querySelectorAll('[data-dropdown-sync]')
    if(dropdownSync) {
        dropdownSync.forEach(dropdownS => {
            dropdownS.addEventListener('click', () => {
                dropdownSync.forEach(dropdown => {
                    if(dropdown === dropdownS) return;
                    const dropdownContent = dropdown.nextElementSibling;
                    closeDropdown(dropdownContent);
                })

                const dropdownContent = dropdownS.nextElementSibling
                toggleDropdown(dropdownContent);
            });
        });
    }

    const dropdownsHeads = document.querySelectorAll('[data-dropdown]');
    if(dropdownsHeads) {
        dropdownsHeads.forEach(dropdownHead => {
            dropdownHead.addEventListener('click', () => {
                const dropdown = dropdownHead.nextElementSibling;
                toggleDropdown(dropdown);
            });
        });
    }
})